import {SET_SEARCH_STRING} from '../constants/types'

export function setSearch(string) {
    return {
        type: SET_SEARCH_STRING,
        string
    };
}